/**
 * Copyright 2017 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import { LOGOUT_USER } from "openstack-uicore-foundation/lib/security/actions";
import {
  AVAILABLE_PAGE_RECEIVED,
  MEDIA_FILE_DELETED,
  MEDIA_FILE_UPLOADED,
  MEDIA_INFO_UPDATED
} from "../actions/sponsor-actions";
import { getUploadStatus } from "../utils/methods";

const DEFAULT_STATE = {
  page: null
};

const updateMediaModules = (modules, moduleId, newMediaUpload) =>
  modules.map((m) => {
    if (m.id === moduleId) {
      const newModule = {
        ...m,
        media_upload: newMediaUpload
      };

      newModule.status = getUploadStatus(newModule);
      return newModule;
    }
    return m;
  });

const sponsorCurrentPageReducer = (state = DEFAULT_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT_USER:
      return DEFAULT_STATE;
    case AVAILABLE_PAGE_RECEIVED: {
      const page = payload.response;

      page.modules = page.modules.map((m) => ({
        ...m,
        status: getUploadStatus(m)
      }));

      return {
        ...state,
        page
      };
    }
    case MEDIA_FILE_UPLOADED: {
      const { moduleId, ...file } = payload;

      const modules = updateMediaModules(state.page.modules, moduleId, file);

      return {
        ...state,
        page: { ...state.page, modules }
      };
    }
    case MEDIA_FILE_DELETED: {
      const { moduleId } = payload;
      const modules = updateMediaModules(state.page.modules, moduleId, null);

      return {
        ...state,
        page: { ...state.page, modules }
      };
    }
    case MEDIA_INFO_UPDATED: {
      const newMediaUpload = payload.response;

      const modules = updateMediaModules(
        state.page.modules,
        newMediaUpload.type_id,
        newMediaUpload
      );

      return {
        ...state,
        page: { ...state.page, modules }
      };
    }
    default:
      return state;
  }
};

export default sponsorCurrentPageReducer;
